export const getCategories = state => {
  return state.categories
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/getters.js